import React, { useCallback, useState } from "react";
import SpectateHeader from "./SpectateHeader";
import TurnCapsule from "./TurnCapsule";
import LiveBoard from "./LiveBoard";
import LiveQuestion from "./LiveQuestion";
import LiveAnswer from "./LiveAnswer";
import LiveWhoAnswered from "./LiveWhoAnswered";
import LiveGameOver from "./LiveGameOver";

const capsuleFlashStyle = `
  @keyframes capsuleFlash {
    0% { transform: translateX(0) scale(1); }
    20% { transform: translateX(-6px) scale(1.06); }
    40% { transform: translateX(6px) scale(1.06); }
    60% { transform: translateX(-4px) scale(1.03); }
    80% { transform: translateX(4px) scale(1.03); }
    100% { transform: translateX(0) scale(1); }
  }
  .capsule-flash {
    animation: capsuleFlash 0.5s ease-in-out;
  }
`;

// Screen switch for the live mirror — same shell as the real game pages.
// Voting is gated to viewers whose team has the turn (server re-validates);
// a blocked tap shakes the turn capsule so the lock explains itself.
const LiveMirror = ({ session }) => {
  const { state, votes, presence, identity, myVote, vote, phase } = session;
  const [flashKey, setFlashKey] = useState(0);

  const canVote =
    phase === "live" &&
    !!identity?.teamId &&
    String(identity.teamId) === String(state?.turnTeamId);

  const tap = useCallback(
    (group, optionKey) => {
      if (!canVote) {
        setFlashKey((k) => k + 1);
        return;
      }
      vote(group, optionKey);
    },
    [canVote, vote]
  );

  if (!state) return null;
  const voting = { counts: votes?.counts || {}, myVote, canVote, tap };
  const screen = state.screen;

  return (
    <div className="h-full w-full flex flex-col font-sans select-none">
      <style>{capsuleFlashStyle}</style>
      <SpectateHeader state={state} presence={presence} />

      {phase === "paused" && (
        <div className="w-full bg-warning/90 text-header text-center font-bold py-2">
          المضيف يعيد الاتصال…
        </div>
      )}

      {(screen === "board" || screen === "paused") && (
        <LiveBoard state={state} presence={presence} voting={voting} />
      )}
      {screen === "question" && (
        <LiveQuestion state={state} presence={presence} voting={voting} />
      )}
      {screen === "answer" && (
        <LiveAnswer state={state} presence={presence} voting={voting} />
      )}
      {screen === "whoAnswered" && (
        <LiveWhoAnswered state={state} presence={presence} voting={voting} />
      )}
      {screen === "over" && <LiveGameOver state={state} />}

      <TurnCapsule
        state={state}
        identity={identity}
        canVote={canVote}
        flashKey={flashKey}
      />
    </div>
  );
};

export default LiveMirror;
